import DateFnsUtils from '@date-io/date-fns'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as css from './DeliveryDatePicker.css'
import { getDatePickerFormatByLocale } from '@utils/get-date-format-by-locale'

export interface IBuyingGroupDeliveryWindow {
  Start: Date
  End: Date
}

interface IDeliveryDateProps {
  deliveryDate: Date | string
  onOrderDeliveryDateChange: (date: Date) => void
  isMacroOrderForNonMasterClient?: boolean
  buyingGroupDeliveryWindow?: IBuyingGroupDeliveryWindow
  disableControls: boolean
  classes?: {
    root?: string
    deliveryDateLabel?: string
    deliveryDatePickerContainer?: string
    inputRoot?: string
    disabledLabel?: string
    formControl?: string
    inputLabelFormControl?: string
  }
  dateFormat?: string
  isShowroomView?: boolean
  convertToCorrectedDate?: boolean
  margin?: any
  shrink?: boolean
}

// TODO: move in new my orders
const DeliveryDatePicker: React.FunctionComponent<IDeliveryDateProps> = ({
  deliveryDate,
  onOrderDeliveryDateChange,
  isMacroOrderForNonMasterClient,
  buyingGroupDeliveryWindow,
  disableControls,
  classes,
  dateFormat,
  convertToCorrectedDate = true,
  margin,
  shrink
}) => {
  /**
   * Ensure that date pass to picker
   * is in UTC time zone
   */
  let deliveryDateValue
  if (convertToCorrectedDate) {
    const deliveryDateData = new Date(deliveryDate)
    const correctedDate = new Date(
      deliveryDateData.getUTCFullYear(),
      deliveryDateData.getUTCMonth(),
      deliveryDateData.getUTCDate(),
      0,
      0,
      0
    )
    deliveryDateValue = deliveryDate && deliveryDate !== 'NA' ? correctedDate : null
  } else {
    deliveryDateValue = deliveryDate && deliveryDate !== 'NA' ? deliveryDate : null
  }
  const { t } = useTranslation()
  return (
    <div
      className={`${css.deliveryDatePickerContainer} ${classes?.deliveryDatePickerContainer}`}
    >
      <MuiPickersUtilsProvider
        utils={DateFnsUtils}
        locale={getDatePickerFormatByLocale()}
      >
        <DatePicker
          InputProps={{
            classes: {
              root: `${css.deliveryDatePickerRoot} ${classes.inputRoot}`,
              input: `${css.deliveryDateInput} ${
                !isMacroOrderForNonMasterClient && !disableControls ? css.clickable : ''
              }`,
              underline: css.deliveryDateUnderline,
              error: css.deliveryDateError,
              disabled: css.disabledInput,
              formControl: css.formControl
            }
          }}
          error={false}
          helperText={null}
          disabled={isMacroOrderForNonMasterClient || disableControls}
          className={`${css.deliveryDatePicker} ${classes?.root}`}
          label={
            isMacroOrderForNonMasterClient
              ? 'NA'
              : deliveryDateValue
              ? null
              : t('order.placeholder.deliveryDate', 'Add Delivery Date')
          }
          name='deliveryWindow'
          disablePast
          type='text'
          margin={margin || 'normal'}
          format={dateFormat || 'd-MMM-yyyy'}
          defaultValue={deliveryDateValue}
          value={isMacroOrderForNonMasterClient ? null : deliveryDateValue}
          onChange={onOrderDeliveryDateChange}
          InputLabelProps={{
            shrink: shrink !== false,
            className: `${classes?.deliveryDateLabel} ${classes?.inputLabelFormControl} ${
              !isMacroOrderForNonMasterClient && !disableControls ? css.clickable : null
            } ${
              !isMacroOrderForNonMasterClient && !deliveryDateValue ? css.italic : null
            } ${disableControls ? classes.disabledLabel : null}`
          }}
          minDate={buyingGroupDeliveryWindow?.Start}
          maxDate={buyingGroupDeliveryWindow?.End}
          okLabel={t('common.label.ok', 'Ok')}
          cancelLabel={t('common.label.cancel', 'Cancel')}
        />
      </MuiPickersUtilsProvider>
    </div>
  )
}

export default DeliveryDatePicker
